import {Map, List, Set} from 'immutable';

import ArtTypes from '~/constants/types/ArtTypes';

import {ART_SEARCH_CONSTANTS} from '~/constants/SearchConstants';
import NotificationTypes from '~/constants/types/NotificationTypes';

function initialState() {
  return Map({
    root: null,
    browsedCategories: List(),
    categories: List(),
    categoryNames: Map(),
    clipartAutofillData: [],
    lastSearch: null,
    recentlyUsed: List(),
    recentlyUsedArt: List(),
    recentlyUsedSnapshot: List(),
    searchHistory: Set(),
    error: null
  });
}

function updateCategoryNames(storeObj, categoryList) {
  return storeObj.withMutations(storeObj => {
    let names = storeObj;
    categoryList.forEach(c => {
      names = names.set(String(c.id), c.name);
    });
    return names;
  });
}

export default function art(state = initialState(), action) {
  switch (action.type) {
    case ArtTypes.BROWSED_CATEGORIES: {
      return state.set('browsedCategories', List(action.payload));
    }

    case ArtTypes.ADD_TO_RECENTLY_USED_ART: {
      return state.update('recentlyUsedArt', recentlyUsedArt =>
        List(recentlyUsedArt.concat(action.payload))
      );
    }

    case ArtTypes.SET_RECENTLY_USED_CLIPART_SNAPSHOT: {
      return state.set('recentlyUsedSnapshot', List(action.payload));
    }

    case ArtTypes.SET_RECENTLY_USED_CLIPART: {
      return state.set('recentlyUsed', List(action.payload));
    }

    case ArtTypes.SELECT_CLIPART: {
      return state.update('recentlyUsed', recentlyUsedClipart => {
        if (!recentlyUsedClipart.includes(action.payload)) {
          if (recentlyUsedClipart.size < 4) {
            return recentlyUsedClipart.unshift(action.payload);
          } else {
            return recentlyUsedClipart.unshift(action.payload).slice(0, 4);
          }
        }
        return recentlyUsedClipart;
      });
    }

    case ArtTypes.SEARCH_LOADED:
    case ArtTypes.CATEGORY_LOADED: {
      const category = {
        name: action.payload.category,
        category: action.payload.resource
      };

      const {_embedded} = action.payload.resource;
      if (
        (_embedded && _embedded.children) ||
        (_embedded && _embedded.category && _embedded.category.children)
      ) {
        const subCategories = _embedded.children || _embedded.category.children;
        const newState = state
          .update('categories', categories => {
            return categories.unshift(category);
          })
          .update('categoryNames', categoryNames => {
            return updateCategoryNames(categoryNames, subCategories);
          });
        return newState.set('error', null);
      } else {
        const newState = state.update('categories', categories => {
          return categories.unshift(category);
        });
        return newState.set('error', null);
      }
    }

    case ArtTypes.CATEGORY_FAILED:
    case ArtTypes.ROOT_FAILED: {
      return state.set('error', action.payload.error);
    }

    case ArtTypes.ROOT_LOADED: {
      const clipartCategories =
        action.payload.resource._embedded.clipart_categories;

      if (clipartCategories) {
        const newState = state.update('categoryNames', categoryNames => {
          return updateCategoryNames(categoryNames, clipartCategories);
        });

        action.payload.resource._embedded.clipart_categories =
          clipartCategories;
        return newState.set('root', action.payload.resource);
      } else {
        return state.set('root', action.payload.resource);
      }
    }

    case ArtTypes.CLIPART_AUTOFILL_DATA_LOADED: {
      const clipartAutofillData = [...action.payload, ...ART_SEARCH_CONSTANTS];
      return state.set('clipartAutofillData', clipartAutofillData);
    }

    case ArtTypes.SET_LAST_SEARCH: {
      return state.set('lastSearch', action.payload);
    }

    case ArtTypes.UPDATE_ART_SEARCH_HISTORY: {
      const keyword = action.payload
        .toLowerCase()
        .split(' ')
        .map(s => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');

      // Set only adds item only to the end of the array
      return state.update('searchHistory', history => history.add(keyword));
    }

    case ArtTypes.CLEAR: {
      return state.set('error', null);
    }

    case ArtTypes.SEARCH_FAILED: {
      return state.set('error', action.payload.error);
    }

    case NotificationTypes.DISMISS: {
      return state.set('error', null);
    }

    default:
      return state;
  }
}
